/* eslint camelcase: 0 */
import moment from 'moment'
import { CalendarEvent } from '@/infrastructure/network/Monitaro/schema/models'
import { EmptyCalendarEventPropsFactory, ICalendarEventProps } from '@/entities/CalendarEvent'

export const toCalendarEventProps = (props: CalendarEvent): ICalendarEventProps => {
  if (!props) {
    return EmptyCalendarEventPropsFactory()
  }

  const { id, name, description, start, end, timed, color, textColor } = props

  return EmptyCalendarEventPropsFactory({
    id,
    name,
    description,
    start: timed ? moment(start).format('YYYY-MM-DD HH:mm') : moment(start).format('YYYY-MM-DD'),
    end: timed ? moment(end).format('YYYY-MM-DD HH:mm') : moment(end).format('YYYY-MM-DD'),
    timed,
    color,
    textColor
  })
}
